import { SxProps } from '@mui/material';

export const sxModalTitle: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: '16px !important',
  lineHeight: '24px',
  color: '#383838 !important',
};

export const sxField: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
};

export const sxFormGrid: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
};

export const sxFormRow: SxProps = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '24px',
  width: '100%',
  '@media (max-width: 599px)': {
    gridTemplateColumns: '1fr',
  },
};

export const sxTextField: SxProps = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    color: '#383838',
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    color: '#383838',
  },
};

export const sxDescricaoTextField: SxProps = {
  ...sxTextField,
  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    minHeight: '120px',
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
  },
  '& .MuiInputAdornment-root': {
    position: 'absolute',
    bottom: 12,
    right: 8,
  },
};

export const sxActions: SxProps = {
  display: 'flex',
  gap: '24px',
  justifyContent: 'center',
  marginTop: '8px',
  '@media (max-width: 599px)': {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
};

export const sxActionsLeft: SxProps = {
  ...sxActions,
  justifyContent: 'flex-start',
};

export const sxSelect: SxProps = {
  ...sxTextField,
  '& .MuiSelect-select': {
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    color: '#383838',
  },
};

export const sxError: SxProps = {
  color: '#D84141',
  fontSize: '12px',
};
